export const floatingLayouts: string[] = ['wrap-left', 'wrap-right'];
